import { ICONS_ENUM } from '@sanlam-glacier/app-common/components';
import { DevToolsMenuItem } from './dev-tools-menu.type';
import { DevToolsUserInfo } from './dev-tool-menus/user-info-tool/DevToolsUserInfo';
import { DevToolsLogs } from './dev-tool-menus/dev-logs-tool/DevToolsLogs';
import { DevToolsEnv } from './dev-tool-menus/dev-env-tool/DevToolsEnv';
import { DevToolsDump } from './dev-tool-menus/dev-dump-tool/DevToolsDump';

export const DevToolsMenuItems: DevToolsMenuItem[] = [
  {
    id: 1,
    name: 'User & Auth Info',
    content: DevToolsUserInfo,
    icon: ICONS_ENUM.ACTION_PROFILE
  },
  {
    id: 2,
    name: 'Logs',
    content: DevToolsLogs,
    icon: ICONS_ENUM.CONTENT_FILTER_LIST
  },
  {
    id: 3,
    name: 'Environment',
    content: DevToolsEnv,
    icon: ICONS_ENUM.ACTION_CODE
  },
  {
    id: 4,
    name: 'Debugging Snapshot',
    content: DevToolsDump,
    icon: ICONS_ENUM.FILE_DOWNLOAD
  }
];
